import { render } from "./Sidebar-menu-akahon.vue?vue&type=template&id=056bf876&scoped=true"
import script from "./Sidebar-menu-akahon.vue?vue&type=script&lang=js"
export * from "./Sidebar-menu-akahon.vue?vue&type=script&lang=js"

import "./Sidebar-menu-akahon.vue?vue&type=style&index=0&id=056bf876&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056bf876"]])

export default __exports__